import { getLanguage, setLanguage, isAvailableLanguage, Language } from '@/i18n'
// @see https://github.com/michaelwittig/node-i18n-iso-countries
// @see https://www.npmjs.com/package/i18n-iso-countries
const countries = require('i18n-iso-countries')

let userLang = getLanguage()
if (
  !isAvailableLanguage(userLang) ||
  !countries.getSupportedLanguages().includes(userLang)
) {
  // 利用可能な言語でない場合英語にしておく
  userLang = 'en'
}

// 利用言語に応じて対象のjsonファイルを読み込む
countries.registerLocale(require(`i18n-iso-countries/langs/${userLang}.json`))

export type SelectOptions = 'alias' | 'official' | 'all'

// 定義されている国名をすべて取得
export function getCountryNames(
  lang: Language = getLanguage(),
  select: SelectOptions = 'alias'
) {
  if (lang === userLang) {
    // 利用言語が指定されていない場合はユーザーの言語を利用
    return countries.getNames(userLang, { select: select })
  }

  if (
    !isAvailableLanguage(lang) ||
    !countries.getSupportedLanguages().includes(lang)
  ) {
    // 利用可能な言語でない場合英語にしておく
    lang = 'en'
  }
  // 利用言語に応じて対象のjsonファイルを読み込む
  countries.registerLocale(require(`i18n-iso-countries/langs/${lang}.json`))
  return countries.getNames(lang, { select: select })
}

// 定義されている国コードかを判定
export function isAvailableCountryCode(countryCode: string) {
  return countries.isValid(countryCode)
}

// 国コードから国名を取得
export function getCountryName(
  code: string,
  lang: Language = getLanguage(),
  select: SelectOptions = 'alias'
) {
  return countries.getName(code, lang, { select: select })
}
